module.exports = __webpack_public_path__ + "img/weidu.4688c96f.png";